import React from "react";
import * as MuiCardActions from "@material-ui/core/CardActions";
import { withStyles } from "@material-ui/core/styles";

interface OptionCardProps extends MuiCardActions.CardActionsProps {
  className?: string;
}

const Mui = MuiCardActions.default;
const CardActionOverride = (props: OptionCardProps) => <Mui {...props} disableSpacing />;
const OptionActions: React.ComponentType<MuiCardActions.CardActionsProps> = withStyles(() => ({}))(CardActionOverride);

export default OptionActions;
